import React, { Component } from 'react'
import { Button } from 'semantic-ui-react'

export default class ColorField extends Component {
  render() {
    let { name, value, onChange } = this.props
    return (
      <div className="form-field-color" ref={el => (this.parent = el)}>
        <input type="color" value={value || ''} name={name} onChange={onChange} />
        {value ? (
          <button
            onClick={e => {
              e.preventDefault()
              onChange({
                name,
                value: false,
              })
            }}>
            Poista
          </button>
        ) : null}
      </div>
    )
  }
}

// class ColorField extends Component {
//   state = {
//     colorpickerOpen: false
//   }

//   handleClick = (e) => {
//     e.preventDefault()

//     if (!this.state.colorpickerOpen) {
//       this.handleOpen()
//     } else {
//       this.handleClose()
//     }
//   }

//   handleChange = (color) => {
//     let { name, value, onChange } = this.props
//     onChange({name, value: color.hex})
//   }

//   handleOpen = () => {
//     document.addEventListener('click', this.handleGlobalClick)
//     this.setState({
//       colorpickerOpen: true
//     })
//   }

//   handleClose = () => {
//     document.removeEventListener('click', this.handleGlobalClick)
//     this.setState({
//       colorpickerOpen: false
//     })
//   }

//   handleGlobalClick = (e) => {
//     let {colorpickerOpen} = this.state
//     if (!colorpickerOpen) return
//     if (this.parent && this.parent.contains(e.target)) return
//     this.handleClose()
//   }

//   render() {
//     let { name, value } = this.props
//     let { colorpickerOpen } = this.state
//     return (
//       <div className="form-field-color" ref={el => this.parent = el}>
//         <Button content={value ? value : 'Valitse väri'}
//           color="blue"
//           icon="eyedropper"
//           labelPosition="left"
//           onClick={this.handleClick}
//           style={value ? {backgroundColor: value} : {}}
//           compact />
//         {colorpickerOpen ? (
//           <SketchPicker
//             color={value || ''}
//             onChangeComplete={this.handleChange}/>
//           ) : null}
//       </div>
//     )
//   }
// }

// export default ColorField
